import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function AdminModeratorRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  const token = localStorage.getItem('token');


  if (!token) {
    return <Navigate to="/login" />;
  }

   if (loading) {
    return null;
  }


  if (!user) {
    return <h2>No tienes permiso para ver esta página</h2>;
  }


  if (user.rol !== 'administrador' && user.rol !== 'moderador') {
    return <h2>No tienes permiso para ver esta página</h2>;
  }

  return children;
}

export default AdminModeratorRoute;
